// eslint-disable-next-line dashboard/use-utilities-window
import theWindow from 'ember-window-mock';
function _downloadPdf(pdf, title) {
  const url = URL.createObjectURL(new Blob([pdf], {
    type: 'application/pdf'
  }));
  const downloadLink = document.createElement('a');
  downloadLink.href = url;
  downloadLink.download = title;
  downloadLink.click();
}
function _printPdf(pdf) {
  const url = URL.createObjectURL(new Blob([pdf], {
    type: 'application/pdf'
  }));
  const pdfWindow = theWindow.open(url);
  pdfWindow?.print();
}
export const pdfMocks = {
  downloadPdf(_pdf, _title) {
    return _downloadPdf(_pdf, _title);
  },
  printPdf(_pdf) {
    return _printPdf(_pdf);
  }
};
export function downloadPdf(pdf, title) {
  return pdfMocks.downloadPdf(pdf, title);
}
export function printPdf(pdf) {
  return pdfMocks.printPdf(pdf);
}